import React from 'react';

/**
 * ShineBorder — Magic UI (ported to React JS)
 * Animated border that travels around the container using CSS mask + radial-gradient.
 *
 * Props:
 *  borderWidth  {number}          px width of the border        default: 1
 *  duration     {number}          animation duration in seconds default: 14
 *  shineColor   {string|string[]} color(s) of the shining light default: '#000000'
 *  className    {string}
 *  style        {object}
 */
export function ShineBorder({
  borderWidth = 1,
  duration = 14,
  shineColor = '#000000',
  className = '',
  style = {},
  ...props
}) {
  const colors = Array.isArray(shineColor) ? shineColor.join(',') : shineColor;

  return (
    <div
      style={{
        '--border-width': `${borderWidth}px`,
        '--duration': `${duration}s`,
        backgroundImage: `radial-gradient(transparent,transparent,${colors},transparent,transparent)`,
        backgroundSize: '300% 300%',
        mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        WebkitMaskComposite: 'xor',
        maskComposite: 'exclude',
        padding: 'var(--border-width)',
        animation: `shine var(--duration) linear infinite`,
        ...style,
      }}
      className={`pointer-events-none absolute inset-0 size-full rounded-[inherit] will-change-[background-position] ${className}`}
      {...props}
    />
  );
}
